import React from "react";
import styles from "./ProfileIncompleteState.module.scss";

interface ProfileIncompleteStateProps {
  missingFields?: string[];
  onGoToCompanyProfile: () => void;
  onGoToUserProfile: () => void;
}

const ProfileIncompleteState: React.FC<ProfileIncompleteStateProps> = ({
  missingFields = [],
  onGoToCompanyProfile,
  onGoToUserProfile,
}) => {
  const hasMissing = missingFields.length > 0;

  return (
    <div className={styles.emptyStateContainer}>
      <div className={styles.content}>
        <img
          src="/assets/editprofile.svg"
          alt="Complete your profile"
          className={styles.icon}
        />

        <h3 className="u-H3-22">Complete your profile</h3>
        <p className="u-P1-18">
          To send broadcasts, add your Company Name and either a Signature or contact details (phone + address/country).
        </p>

        {hasMissing && (
          <div className={styles.missingBox} aria-label="Missing information">
            <div className={styles.missingTitle + " u-P1-18-semi-bold"}>
              Missing information
            </div>
            <ul className={`${styles.missingList} u-P1-18-list`}>
              {missingFields.map((field, idx) => (
                <li key={`${field}-${idx}`} className={styles.missingItem}>
                  <span className={styles.bullet} aria-hidden="true" />
                  <span>{field}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className={styles.buttonRow} aria-label="Profile actions">
          <button
            type="button"
            className={styles.completeButton}
            onClick={onGoToCompanyProfile}
            aria-label="Go to company profile"
          >
            <span className="u-P2-16-medium">Company profile</span>
          </button>
          <button
            type="button"
            className={styles.secondaryButton}
            onClick={onGoToUserProfile}
            aria-label="Go to user profile"
          >
            <span className="u-P2-16-medium">User profile</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileIncompleteState;

